import { SubscriptionState } from '../Subscriptions.js';

class SubscriptionFeatureBehavioursMapper {
  static createSubscriptionFeatureBehavioursFromResponse(_ref) {
    let {
      subscription,
      client_feature_behaviours
    } = _ref;
    const clientFeatureBehavioursByFeature = Object.fromEntries(client_feature_behaviours.map(cfb => [cfb.feature_name, {
      featureName: cfb.feature_name,
      behaviourProperties: cfb.behaviour_properties
    }]));
    return {
      subscription: subscription && {
        id: subscription.id,
        planName: subscription.plan_name,
        planCode: subscription.plan_code,
        currentPeriodEndsAt: subscription.current_period_ends_at,
        state: subscription.state,
        isActive: subscription.state === SubscriptionState.ACTIVE,
        isCanceled: subscription.state === SubscriptionState.CANCELED,
        isActiveOrCanceled: [SubscriptionState.ACTIVE, SubscriptionState.CANCELED].includes(subscription.state),
        isExpired: subscription.state === SubscriptionState.EXPIRED
      },
      clientFeatureBehaviours: clientFeatureBehavioursByFeature
    };
  }
  static createSubscriptionPlanFeaturesFromResponse(data) {
    return Object.fromEntries(data.map(f => [f, true]));
  }
}

export { SubscriptionFeatureBehavioursMapper };
//# sourceMappingURL=SubscriptionFeatureBehavioursMapper.js.map
